import React from "react";
import { useVehicleSpecificationContext } from "./vehicleSpecificationContext";
import { Button, Select } from "@cognitranlimited/itis-web";
import { HIDDEN_FIELDS, useForm } from "./useForm";
var VehicleSpecificationForm = function (props) {
    var _a = useForm(props), selectedOptions = _a.selectedOptions, fieldsToDisplay = _a.fieldsToDisplay, handleSelectChange = _a.handleSelectChange, getFieldOptions = _a.getFieldOptions, submit = _a.submit;
    var strings = useVehicleSpecificationContext().strings.vehicleSpecification;
    return (React.createElement("form", { action: "POST", className: "VehicleSpecificationForm" },
        React.createElement("div", { className: "VehicleSpecificationForm-button" },
            React.createElement(Button, { onClick: submit }, strings.form.submit)),
        fieldsToDisplay.map(function (key) {
            if (HIDDEN_FIELDS.includes(key)) {
                return null;
            }
            return (React.createElement("div", { key: key, className: "VehicleSpecificationForm-field" },
                React.createElement("label", { htmlFor: key }, key),
                React.createElement(Select, { id: key, value: selectedOptions[key], placeholder: strings.form.placeholder, onChange: function (value) {
                        return handleSelectChange(key, value !== null && value !== void 0 ? value : "");
                    }, items: getFieldOptions(key).map(function (_a) {
                        var key = _a[0], value = _a[1];
                        return [
                            key.toString(),
                            value.toString(),
                        ];
                    }) })));
        })));
};
export { VehicleSpecificationForm };
